import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import firebase from 'firebase/compat/app';
import { StateService } from 'src/app/services/shared/state.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['../login/login.component.scss']
})
export class RegisterComponent implements OnInit {

  constructor(public fb: FormBuilder,
    public stateService: StateService,
    public dialogRef: MatDialogRef<RegisterComponent>) { }

  ngOnInit(): void {
    this.InitializeRegisterForm();
    this.InitializeRecaptcha();
  }

  registerForm!: FormGroup;
  recaptchaVerifier!: firebase.auth.RecaptchaVerifier;
  isRecaptchaVerified: boolean = false;

  private InitializeRegisterForm() {
    this.registerForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
      repeatPassword: ['', Validators.required,]
    }, { validator: this.passwordMatchValidator });
  }

  private InitializeRecaptcha() {
    this.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
      'recaptcha-container',
      { size: 'invisible' }
    );
    this.recaptchaVerifier.render();
    this.recaptchaVerifier.verify()
      .then(() => {
        this.isRecaptchaVerified = true;
      })
      .catch(error => {
        this.isRecaptchaVerified = false;
      });
  }



  passwordMatchValidator(control: AbstractControl): { [key: string]: boolean } | null {
    const password = control.get('password');
    const repeatPassword = control.get('repeatPassword');

    if (password && repeatPassword && password.value !== repeatPassword.value) {
      return { 'passwordMismatch': true };
    }
    return null;
  }

  public RegisterWithEmailAndPassword() {
    const data = this.registerForm.getRawValue();
    this.stateService.SignUpEmailAndPassword(data.email, data.password, this.recaptchaVerifier, () => this.CloseModal());
    //window.location.href = 'https://inceptly.typeform.com/to/USvF7V';
  }

  public RegisterWithGoogle() {
    const data = this.registerForm.getRawValue();
    this.stateService.SignInWithGoogle(this.recaptchaVerifier, () => this.CloseModal())
    //window.location.href = 'https://inceptly.typeform.com/to/USvF7V';
  }

  public CloseModal() {
    this.dialogRef.close();
  }

}
